export default __webpack_public_path__ + "static/media/keras.494b1e5e.svg";